<template>
    <div>
     <v-container fluid>
      <form @submit.prevent="updateCenterDetails">
        <div class="main-section-title mb-4">Edit Pre-school Details</div>
        <!-- Basic Information -->
        <div class="section-wrapper">
        <div class="tab-label">
          <span>Basic Information</span>
        </div>
        <v-card class="basic-info-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="preschoolname"
                  label="1. Select Preschoolname *"
                  placeholder="Select PrechoolName"
                  :items="allFranchisees"
                  key="id"
                  item-value="id"
                  item-text="companyName"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="district"
                  label="2. Select District *"
                  placeholder="Select District"
                  outlined dense
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="block"
                  label="3. Select Block *"
                  placeholder="Select Block"
                  outlined dense
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="village"
                  label="4. Select village *"
                  placeholder="Select village"
                  outlined dense
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="nearestPrimarySchool"
                  label="5. Nearest Primary School *"
                  placeholder="Nearest Primary School"
                  outlined dense
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="cluster"
                  label="6. Cluster"
                  placeholder="Cluster"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="preschoolnumber"
                  label="7. Pre-School Number (Auto-Generated)"
                  placeholder="Preschool Number"
                  outlined dense
                  readonly
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="address"
                  label="8. Address / Landmark"
                  placeholder="Enter Address / Landmark"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="management"
                  :items="PreschoolManagement"
                  item-text="text"
                  item-value="value"
                  label="9. Management"
                  placeholder="Select Management"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="medium"
                  :items="PreschoolMedium"
                  item-text="text"
                  item-value="value"
                  label="10. Medium"
                  placeholder="Select Medium"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="category"
                  :items="PreschoolCategory"
                  item-text="text"
                  item-value="value"
                  label="11. Category"
                  placeholder="Select Category"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="preschoolEmail"
                  label="12. Pre-School Email"
                  placeholder="Enter Pre-School Email"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="preschoolContactNo"
                  label="13. Pre-School Contact No."
                  placeholder="Enter Pre-School Contact No."
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="preschoolacademicYear"
                  :items="PreschoolAcademicYear"
                  item-text="text"
                  item-value="value"
                  label="14. Academic Year from which school has started functioning"
                  placeholder="Select Academic Year"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="preschoolwebsite"
                  label="15. Pre-School Website(If exists)"
                  placeholder="Preschool Website"
                  outlined dense
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="lowestClass"
                  :items="PreschoolLowestclass"
                  item-text="text"
                  item-value="value"
                  label="16. Lowest Class *"
                  placeholder="Select Lowest Class"
                  outlined dense
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete v-model="highestClass"
                  :items="Preschoolhighestclass"
                  item-text="text"
                  item-value="value"
                  label="17. Highest Class *"
                  placeholder="Select Highest Class"
                  outlined dense
                  required
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        </div>
        <!-- Management Details -->
        <div class="section-wrapper">
          <div class="tab-label">
            <span>Management Details</span>
          </div>
          <v-card class="basic-info-card">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field v-model="managementreptname"
                    label="1. Management Representative Name"
                    placeholder="Enter Name"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="managementreptemail"
                    label="2. Management Representative Email"
                    placeholder="Enter Email"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="managementreptmobile"
                    label="3. Management Representative Mobile"
                    placeholder="Enter Mobile No."
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="managementreptdesignation"
                    :items="ManagementDesignation"
                    item-text="text"
                    item-value="value"
                    label="4. Management Representative Designation"
                    placeholder="Select Designation"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="schoolregistrationnumber"
                    label="5. School Registration Number (If Any)"
                    placeholder="Enter Registration Number"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="principalname"
                    label="6. Principal/Head Master/In-charge Name *"
                    placeholder="Enter Name"
                    outlined dense
                    required
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="principalemail"
                    label="7. Principal/Head Master/In-charge Email"
                    placeholder="Enter Email"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="principalmobile"
                    label="8. Principal/Head Master/In-charge Mobile*"
                    placeholder="Enter Mobile"
                    outlined dense
                    required
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="principalhighqualification"
                    :items="PrinciplehighQualification"
                    item-text="text"
                    item-value="value"
                    label="9. Principal/Head Master/In-charge Highest Qualification"
                    placeholder="Select Qualification"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete v-model="principalprofqualification"
                    :items="PrincipleprofQualification"
                    item-text="text"
                    item-value="value"
                    label="10. Principal/Head Master/In-charge Professional Qualification"
                    placeholder="Enter Qualification"
                    outlined dense
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-file-input
                    v-model="principalCertificate"
                    accept=".pdf"
                    label="11. Principal/Head Master/In-charge Educational & Professional Certificate"
                    placeholder="Choose file"
                    outlined dense
                    show-size
                    :rules="[fileRules]"
                    @change="onFileChange($event, 'principal')"
                  />
                  <small class="red--text">Note: Select a PDF file smaller than 1 MB</small>
                    <div v-if="(principalCertificate == null || principalCertificate === '') && existingCertificates.principalCertificate">
                    <v-btn small color="primary" @click="downloadCertificate(existingCertificates.principalCertificate)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                        View Existing PDF
                    </v-btn>
                    <v-icon
                      small
                      color="red"
                      @click="removeCertificate('principalCertificate')"
                      class="ml-2"
                      title="Remove Uploaded File"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <!-- Student and Classroom Details -->
        <div class="section-wrapper">
          <div class="tab-label">
            <span>Student and Classroom Details</span>
          </div>
          <v-card class="basic-info-card">
            <v-card-text>
              <v-row>
                <v-col v-for="classObj in classesToShow" :key="classObj.value" cols="12" md="4">
                  <v-card class="student-class-card" flat>
                    <v-card-title class="justify-center font-weight-bold">
                      {{ classObj.text }}
                    </v-card-title>
                    <v-card-text>
                      <v-text-field
                        v-model="classDetails[classObj.value].boys"
                        label="Total No. of Boys:"
                        outlined dense type="number"
                      />
                      <v-text-field
                        v-model="classDetails[classObj.value].girls"
                        label="Total No. of Girls:"
                        outlined dense type="number"
                      />
                      <v-text-field
                        :value="Number(classDetails[classObj.value].boys || 0) + Number(classDetails[classObj.value].girls || 0)"
                        label="Total:"
                        outlined dense readonly
                      />
                      <v-text-field
                        v-model="classDetails[classObj.value].classrooms"
                        label="Total Classrooms:"
                        outlined dense type="number"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <!-- Infrastructure Details -->
        <div class="section-wrapper">
          <div class="tab-label">
            <span>Infrastructure Details</span>
          </div>
          <v-card class="basic-info-card">
            <v-card-text>
              <v-row>
                <!-- 1. Building -->
                <v-col cols="12" md="3">
                  <span class="font-weight-bold">1. Building</span>
                  <v-radio-group v-model="infra.buildingType" row>
                    <v-radio label="Owned" value="owned" />
                    <v-radio label="Leased" value="leased" />
                  </v-radio-group>
                  <span>Building Completion Certificate</span>
                  <v-file-input
                    v-model="infra.buildingCert"
                    accept=".pdf"
                    dense outlined hide-details
                    @change="onFileChange($event, 'building')"
                    :rules="[fileRules]"
                  />
                  <small class="red--text">Note: Select a PDF file with a size less than 1 MB</small>
                    <div v-if="(infra.buildingCert == null || infra.buildingCert === '') && existingCertificates.buildingCert">
                    <v-btn small color="primary" @click="downloadCertificate(existingCertificates.buildingCert)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                        View Existing PDF
                    </v-btn>
                    <v-icon
                      small
                      color="red"
                      @click="removeCertificate('buildingCert')"
                      class="ml-2"
                      title="Remove Uploaded File"
                    >
                      mdi-close-circle
                    </v-icon>
                  </div>
                </v-col>
                <!-- 2. Is Health Hygiene maintained? -->
                <v-col cols="12" md="2">
                  <span class="font-weight-bold">2. Is Health Hygiene maintained?</span>
                  <v-radio-group v-model="infra.healthHygiene" row>
                    <v-radio label="Yes" value="yes" />
                    <v-radio label="No" value="no" />
                  </v-radio-group>
                </v-col>
                <!-- 3. Is Sanitation maintained? -->
                <v-col cols="12" md="2">
                  <span class="font-weight-bold">3. Is Sanitation maintained?</span>
                  <v-radio-group v-model="infra.sanitation" row>
                    <v-radio label="Yes" value="yes" />
                    <v-radio label="No" value="no" />
                  </v-radio-group>
                </v-col>
                <!-- 4. Is Cleanliness maintained? -->
                <v-col cols="12" md="3">
                  <span class="font-weight-bold">4. Is Cleanliness maintained?</span>
                  <v-radio-group v-model="infra.cleanliness" row>
                    <v-radio label="Yes" value="yes" />
                    <v-radio label="No" value="no" />
                  </v-radio-group>
                  <template v-if="infra.cleanliness !== 'no'">
                    <span>Cleanliness Maintenance Certificate</span>
                    <v-file-input
                      v-model="infra.cleanlinessCert"
                      accept=".pdf"
                      dense outlined hide-details
                      @change="onFileChange($event, 'cleanliness')"
                      :rules="[fileRules]"
                    />
                    <small class="red--text">Note: Select a PDF file with a size less than 1 MB</small>
                      <div v-if="(infra.cleanlinessCert == null ||infra.cleanlinessCert === '') && existingCertificates.cleanlinessCert">
                      <v-btn small color="primary" @click="downloadCertificate(existingCertificates.cleanlinessCert)">
                      <v-icon left small color="primary">mdi-download</v-icon>
                       View Existing PDF
                    </v-btn>
                    <v-icon
                      small
                      color="red"
                      @click="removeCertificate('cleanlinessCert')"
                      class="ml-2"
                      title="Remove Uploaded File"
                    >
                      mdi-close-circle
                    </v-icon>
                    </div>
                  </template>
                </v-col>
                <!-- 5. Facility -->
                <v-col cols="12" md="2">
                  <span class="font-weight-bold">5. Facility</span>
                  <v-checkbox v-model="infra.facility" label="Playground" value="playground" hide-details />
                  <v-checkbox v-model="infra.facility" label="Water Tank" value="water_tank" hide-details />
                  <v-checkbox v-model="infra.facility" label="Occupational Safety" value="occupational_safety" hide-details />
                  <v-checkbox v-model="infra.facility" label="CCTV" value="cctv" hide-details />
                </v-col>
              </v-row>
              <v-row>
                <!-- 6. Total Number of Washrooms -->
                <v-col cols="12" md="2">
                  <span class="font-weight-bold">6. Total Number of Washrooms</span>
                  <v-text-field
                    v-model="infra.washrooms"
                    type="number" min="0"
                    dense outlined
                  />
                </v-col>
                <!-- 7. Area of Pre-School (Sq ft) -->
                <v-col cols="12" md="3">
                  <span class="font-weight-bold">7. Area of Pre-School (Sq ft)</span>
                  <v-text-field
                    v-model="infra.area"
                    placeholder="Enter area..."
                    dense outlined
                  />
                </v-col>
                <!-- 8. Water Storage Capacity (Liters) -->
                <v-col cols="12" md="3">
                  <span class="font-weight-bold">8. Water Storage Capacity (Liters)</span>
                  <v-text-field
                    v-model="infra.waterStorage"
                    placeholder="Enter capacity..."
                    dense outlined
                  />
                </v-col>
                <!-- 9. Are attendants available in the pre-school? -->
                <v-col cols="12" md="6">
                  <span class="font-weight-bold">9. Are attendants available in the pre-school?</span>
                  <v-radio-group v-model="infra.attendants" row>
                    <v-radio label="Yes" value="yes" />
                    <v-radio label="No" value="no" />
                  </v-radio-group>
                  <template v-if="infra.attendants === 'yes'">
                    <v-row>
                      <v-col cols="12" sm="4" class="d-flex align-center">
                        <span class="mr-2">Male :</span>
                        <v-text-field
                          v-model.number="infra.attendantMale"
                          type="number" min="0"
                          dense outlined class="mt-0"
                          hide-details
                        />
                      </v-col>
                      <v-col cols="12" sm="4" class="d-flex align-center">
                        <span class="mr-2">Female :</span>
                        <v-text-field
                          v-model.number="infra.attendantFemale"
                          type="number" min="0"
                          dense outlined class="mt-0"
                          hide-details
                        />
                      </v-col>
                      <v-col cols="12" sm="4" class="d-flex align-center">
                        <span class="mr-2">Total :</span>
                        <v-text-field
                          :value="infra.attendantMale + infra.attendantFemale"
                          readonly dense outlined class="mt-0"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
                <!-- 10. Children With Special Needs -->
                <v-col cols="12" md="2">
                  <span class="font-weight-bold">10. Children With Special Needs</span>
                  <v-radio-group v-model="infra.specialNeeds" row>
                    <v-radio label="Yes" value="yes" />
                    <v-radio label="No" value="no" />
                  </v-radio-group>
                </v-col>
                <!-- Show this block only if 'Yes' is selected -->
                <template v-if="infra.specialNeeds === 'yes'">
                  <v-col v-for="classObj in classesToShow" :key="classObj.value" cols="12" md="3">
                    <span class="font-weight-bold">{{ classObj.text }}:</span>
                    <v-text-field
                      v-model="specialNeedsInput[classObj.value].boys"
                      label="Boys"
                      dense outlined type="number" class="mt-1"
                      :ref="`cwsnBoysInput_${classObj.value}`"
                    />
                    <v-text-field
                      v-model="specialNeedsInput[classObj.value].girls"
                      label="Girls"
                      dense outlined type="number" class="mt-1"
                      :ref="`cwsnGirlsInput_${classObj.value}`"
                    />
                    <v-text-field
                      :value="Number(specialNeedsInput[classObj.value].boys || 0) + Number(specialNeedsInput[classObj.value].girls || 0)"
                      label="Total"
                      dense
                      outlined
                      readonly
                      class="mt-1"
                    />
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <!-- Staff Details -->
        <div class="section-wrapper">
          <div class="tab-label">
            <span>Staff Details</span>
          </div>
          <v-card class="staff-info-card">
            <v-card-text>
              <div v-for="(staff, index) in staffList" :key="index">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="staff.name"
                      label="Name *"
                      placeholder="Enter Name"
                      outlined dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="staff.type"
                      :items="['Teaching', 'Non-Teaching', 'Other']"
                      label="Teaching Type *"
                      placeholder="Select Teaching Type"
                      outlined dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="staff.highestEdu"
                      :items="['SSC', 'HSC', 'Graduate', 'Post Graduate','Other']"
                      label="Highest Educational Qualification *"
                      placeholder="Select Qualification"
                      outlined dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="staff.profQualification"
                      :items="['ECCE Certified', 'SCERT Certified', 'D.Ed', 'B.Ed', 'Other']"
                      label="Professional Qualification *"
                      placeholder="Select Qualification"
                      outlined dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="dobMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="staff.dob"
                          label="Date of Birth *"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="staff.dob"
                        @input="dobMenu = false"
                        :max="maxDate"
                        color="primary"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="dojMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="staff.doj"
                          label="Date of Joining *"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="staff.doj"
                        @input="dojMenu = false"
                        :max="maxDate"
                        color="primary"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="staff.gender"
                      :items="['Male', 'Female', 'Transgender']"
                      label="Gender *"
                      placeholder="Select Gender"
                      outlined dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <label class="mb-2 font-weight-medium">Professional Qualification Certifications *</label>
                    <v-checkbox
                      v-for="cert in ['ECCE', 'SCERT', 'Other']"
                      :key="cert"
                      v-model="staff.certifications"
                      :label="cert"
                      :value="cert"
                      dense hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-btn
                      small icon color="primary"
                      v-if="index === staffList.length - 1"
                      class="mt-6"
                      @click="addStaff"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      small icon color="red"
                      @click="removeStaff(index)"
                      v-if="staffList.length > 1"
                      class="mt-6"
                        >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-divider class="my-4" v-if="index < staffList.length - 1" />
              </div>
            </v-card-text>
          </v-card>
        </div>
        <v-btn color="success" elevation="1" type="submit">
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
        <v-btn color="grey" elevation="1" class="ml-2" @click="cancelEdit">
          <v-icon left>mdi-cancel</v-icon>
          Cancel
        </v-btn>
      </form>
     </v-container>
     <v-card-component >
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Logs : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card-text>

        <v-divider class=" my-0 " />
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="preschoollist"
          :search="search"
        >
        <template v-slot:item.createdAt="{ item }">
          {{ new Date(item.createdAt).toLocaleDateString() }}
        </template>
          <template v-slot:item.preSchoolName="{ item }">
            {{ item.preSchoolName || '-' }}
          </template>
          <template v-slot:item.district="{ item }">
            {{ item.district || '-' }}
          </template>
          <template v-slot:item.village="{ item }">
            {{ item.village || '-' }}
          </template>
          <template v-slot:item.lowestClass="{ item }">
            {{ item.lowestClass || '-' }}
          </template>
          <template v-slot:item.updatedBy="{ item }">
            {{ item.updatedBy || '-' }}
          </template>
          <template v-slot:item.healthHygieneMaintained="{ item }">
            {{ item.healthHygieneMaintained === true || item.healthHygieneMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.sanitationMaintained="{ item }">
            {{ item.sanitationMaintained === true || item.sanitationMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.cleanlinessMaintained="{ item }">
            {{ item.cleanlinessMaintained === true || item.cleanlinessMaintained === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.attendantsAvailable="{ item }">
            {{ item.attendantsAvailable === true || item.attendantsAvailable === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:item.childrenSpecialneeds="{ item }">
            {{ item.childrenSpecialneeds === true || item.childrenSpecialneeds === 'true' ? 'Yes' : 'No' }}
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        </v-card-component>
       <v-dialog v-model="popup" max-width="400">
        <v-card>
          <v-card-title class="headline">{{ popupMsg }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="popup = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    </template>

<script>
import constants from '@/utils/constants'
export default {
  name: 'editpreschooldetails',
  props: { id: { type: String, required: true } },
  data () {
    return {
      // all the same data variables as in create page
      preschoolname: '',
      district: '',
      block: '',
      village: '',
      nearestPrimarySchool: '',
      cluster: '',
      preschoolnumber: '',
      address: '',
      management: '',
      medium: '',
      category: '',
      preschoolEmail: '',
      preschoolContactNo: '',
      preschoolacademicYear: '',
      preschoolwebsite: '',
      lowestClass: '',
      highestClass: '',
      managementreptname: '',
      managementreptemail: '',
      managementreptmobile: '',
      managementreptdesignation: '',
      schoolregistrationnumber: '',
      principalname: '',
      principalemail: '',
      principalmobile: '',
      principalhighqualification: '',
      principalprofqualification: '',
      principalCertificate: null,
      PreschoolManagement: constants.PreschoolManagement,
      PreschoolMedium: constants.PreschoolMedium,
      PreschoolCategory: constants.PreschoolCategory,
      PreschoolAcademicYear: Array.from({ length: 2025 - 1970 + 1 }, (_, i) => {
        let year = (1970 + i).toString()
        return { text: year, value: year }
      }),
      PreschoolLowestclass: [
        { text: 'Nursery', value: 'nursery' }
      ],
      Preschoolhighestclass: [
        { text: 'PP II', value: 'pp II' }
      ],
      ManagementDesignation: [
        { text: 'Chairman', value: 'chairman' },
        { text: 'Director', value: 'director' },
        { text: 'Secretary', value: 'secretary' },
        { text: 'Other', value: 'other' }
      ],
      PrinciplehighQualification: [
        { text: 'SSC', value: 'ssc' },
        { text: 'HSC', value: 'hsc' },
        { text: 'Graduate', value: 'graduate' },
        { text: 'Post Graduate', value: 'post graduate' },
        { text: 'Other', value: 'other' }
      ],
      PrincipleprofQualification: [
        { text: 'ECCE Certified', value: 'ecce certified' },
        { text: 'SCERT Certified', value: 'scert certified' },
        { text: 'D.Ed', value: 'd.ed' },
        { text: 'B.Ed', value: 'b.ed' },
        { text: 'Other', value: 'other' }
      ],
      allClasses: [
        { text: 'Nursery', value: 'nursery' },
        { text: 'PP II', value: 'pp II' }
      ],
      classDetails: {
        nursery: { boys: '', girls: '', classrooms: '' },
        'pp II': { boys: '', girls: '', classrooms: '' }
      },
      specialNeeds: {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      },
      specialNeedsInput: {
        nursery: { boys: '', girls: '' },
        'pp II': { boys: '', girls: '' }
      },
      popup: false,
      popupMsg: '',
      infra: {
        buildingType: '',
        buildingCert: null,
        healthHygiene: '',
        sanitation: '',
        cleanliness: '',
        cleanlinessCert: null,
        facility: [],
        washrooms: '',
        area: '',
        waterStorage: '',
        attendants: '',
        specialNeeds: '',
        attendantMale: 0,
        attendantFemale: 0
      },
      existingCertificates: {
        principalCertificate: null,
        buildingCert: null,
        cleanlinessCert: null
      },
      staffList: [
        {
          name: '',
          type: '',
          highestEdu: '',
          profQualification: '',
          dob: '',
          doj: '',
          gender: '',
          certifications: []
        }
      ],
      allFranchisees: [],
      total: 0,
      search: '',
      preschoollist: [],
      headers: [
        { text: 'Date', value: 'createdAt', sortable: true },
        { text: 'Franchisee/Center', value: 'franchisee.companyName', sortable: true },
        { text: 'District', value: 'district', sortable: true },
        { text: 'Block', value: 'centerDetails.block', sortable: true },
        { text: 'Village', value: 'village', sortable: true },
        { text: 'Nearest Primary School', value: 'nearestPrimarySchool', sortable: true },
        { text: 'Cluster', value: 'cluster', sortable: true },
        { text: 'Pre-School Number', value: 'preSchoolNumber', sortable: true },
        { text: 'Address / Landmark', value: 'addressLandmark', sortable: true },
        { text: 'Management', value: 'management', sortable: true },
        { text: 'Medium', value: 'medium', sortable: true },
        { text: 'Category', value: 'category', sortable: true },
        { text: 'Pre-School Email', value: 'preSchoolEmail', sortable: true },
        { text: 'Pre-School Contact No', value: 'preSchoolContactNo', sortable: true },
        { text: 'Academic Year Started', value: 'academicYearStarted', sortable: true },
        { text: 'Pre-School Website', value: 'preSchoolWebsite', sortable: true },
        { text: 'Lowest Class', value: 'lowestClass', sortable: true },
        { text: 'Highest Class', value: 'highestClass', sortable: true },
        // Management Details
        { text: 'Mgmt Rep Name', value: 'representativeName', sortable: true },
        { text: 'Mgmt Rep Email', value: 'representativeEmail', sortable: true },
        { text: 'Mgmt Rep Mobile', value: 'representativeMobile', sortable: true },
        { text: 'Mgmt Rep Designation', value: 'representativeDesignation', sortable: true },
        { text: 'School Registration No', value: 'schoolRegistrationNumber', sortable: true },
        { text: 'Principal Name', value: 'principalName', sortable: true },
        { text: 'Principal Email', value: 'principalEmail', sortable: true },
        { text: 'Principal Mobile', value: 'principalMobile', sortable: true },
        { text: 'Principal Highest Qual.', value: 'principalHighestQualification', sortable: true },
        { text: 'Principal Professional Qual.', value: 'principalProfessionalQualification', sortable: true },
        { text: 'Principal Certificate', value: 'principalCertificate', sortable: true },
        // Student/Classroom Details
        { text: 'Nursery Boys', value: 'totalnurseryboys', sortable: true },
        { text: 'Nursery Girls', value: 'totalnurserygirls', sortable: true },
        { text: 'Nursery Classrooms', value: 'nurserytotalClassrooms', sortable: true },
        { text: 'PP II Boys', value: 'totalpp2boys', sortable: true },
        { text: 'PP II Girls', value: 'totalpp2girls', sortable: true },
        { text: 'PP II Classrooms', value: 'pp2totalClassrooms', sortable: true },
        // Infrastructure Details
        { text: 'Building Type', value: 'buildingType', sortable: true },
        { text: 'Building Completion Certificate', value: 'buildingCompletionCertificate', sortable: true },
        { text: 'Health Hygiene Maintained', value: 'healthHygieneMaintained', sortable: true },
        { text: 'Sanitation Maintained', value: 'sanitationMaintained', sortable: true },
        { text: 'Cleanliness Maintained', value: 'cleanlinessMaintained', sortable: true },
        { text: 'Cleanliness Maintenance Certificate', value: 'cleanlinessMaintenanceCertificate', sortable: true },
        { text: 'Facility', value: 'facility', sortable: true },
        { text: 'Total Washrooms', value: 'totalWashrooms', sortable: true },
        { text: 'Area (sqft)', value: 'areapreSchoolsqft', sortable: true },
        { text: 'Water Storage (Liters)', value: 'waterStorageCapacityLiters', sortable: true },
        { text: 'Attendants Available', value: 'attendantsAvailable', sortable: true },
        { text: 'Attendants Male', value: 'attendantsMale', sortable: true },
        { text: 'Attendants Female', value: 'attendantsFemale', sortable: true },
        // Special Needs
        { text: 'Children with Special Needs', value: 'childrenSpecialneeds', sortable: true },
        { text: 'SN Nursery Boys', value: 'specialneedsNurseryBoys', sortable: true },
        { text: 'SN Nursery Girls', value: 'specialneedsNurseryGirls', sortable: true },
        { text: 'SN PP II Girls', value: 'specialneedsPP2Girls', sortable: true },
        { text: 'SN PP II Boys', value: 'specialneedsPP2Boys', sortable: true },
        // Staff Details (as joined strings)
        { text: 'Staff Names', value: 'staffName', sortable: true },
        { text: 'Staff Types', value: 'staffType', sortable: true },
        { text: 'Staff Highest Edu.', value: 'staffHighestedu', sortable: true },
        { text: 'Staff Professional Qual.', value: 'staffProfessionalQualification', sortable: true },
        { text: 'Staff DOBs', value: 'staffDateOfBirth', sortable: true },
        { text: 'Staff DOJs', value: 'staffDateOfJoin', sortable: true },
        { text: 'Staff Genders', value: 'staffGender', sortable: true },
        { text: 'Staff Certifications', value: 'staffCertifications', sortable: true },
        { text: 'Edited By', value: 'updatedBy', sortable: true }
      ],
      principalCertificateRemoved: false,
      buildingCertRemoved: false,
      cleanlinessCertRemoved: false,
      dobMenu: false,
      dojMenu: false,
      maxDate: new Date().toISOString().substr(0, 10)
    }
  },
  async created () {
    await this.getAllFranchisee()
    await this.fetchDetails()
    await this.getCenterLogDetails()
  },
  computed: {
    classesToShow () {
      if (!this.lowestClass && !this.highestClass) return this.allClasses
      if (this.lowestClass && !this.highestClass) return []
      if (!this.lowestClass && this.highestClass) return this.allClasses.filter(c => c.value === this.highestClass)
      if (this.lowestClass && this.highestClass) {
        return this.allClasses.filter(
          c => c.value === this.lowestClass || c.value === this.highestClass
        )
      }
      return []
    }
  },
  methods: {
    onFileChange (file, type) {
      if (file) {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
        if (!allowedTypes.includes(file.type)) {
          this.showValidation('File must be a PDF, JPEG, JPG, or PNG')
          if (type === 'principal') this.principalCertificate = null
          if (type === 'building') this.infra.buildingCert = null
          if (type === 'cleanliness') this.infra.cleanlinessCert = null
          return
        }
        if (file.size > 1024 * 1024) {
          this.showValidation('File must be less than 1 MB')
          if (type === 'principal') this.principalCertificate = null
          if (type === 'building') this.infra.buildingCert = null
          if (type === 'cleanliness') this.infra.cleanlinessCert = null
        }
        if (type === 'principal') this.principalCertificate = file
        if (type === 'building') this.infra.buildingCert = file
        if (type === 'cleanliness') this.infra.cleanlinessCert = file
      }
    },
    showValidation (msg) {
      this.popupMsg = msg
      this.popup = true
    },
    fileRules (value) {
      if (!value) return true
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(value.type)) {
        return 'File must be a PDF, JPEG, JPG, or PNG'
      }
      if (value.size > 1024 * 1024) return 'File must be less than 1 MB'
      return true
    },
    async fetchDetails () {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/centerdetailsPreschool/centerdetails/${this.id}`
        )
        const data = res.data?.data || {}
        // this.preschoolname = data.preSchoolName || ''
        let idOrName = data.preSchoolName || ''
        let match = this.allFranchisees.find(f => String(f.id) === String(idOrName))
        if (match) {
          this.preschoolname = match.id
        } else {
          match = this.allFranchisees.find(f => f.companyName === idOrName)
          this.preschoolname = match ? match.id : ''
        }
        this.district = data.district || ''
        this.block = data.block || ''
        this.village = data.village || ''
        this.nearestPrimarySchool = data.nearestPrimarySchool || ''
        this.cluster = data.cluster || ''
        this.preschoolnumber = data.preSchoolNumber || ''
        this.address = data.addressLandmark || ''
        this.management = data.management || ''
        this.medium = data.medium || ''
        this.category = data.category || ''
        this.preschoolEmail = data.preSchoolEmail || ''
        this.preschoolContactNo = data.preSchoolContactNo || ''
        this.preschoolacademicYear = data.academicYearStarted || ''
        this.preschoolwebsite = data.preSchoolWebsite || ''
        this.lowestClass = data.lowestClass || ''
        this.highestClass = data.highestClass || ''
        this.managementreptname = data.representativeName || ''
        this.managementreptemail = data.representativeEmail || ''
        this.managementreptmobile = data.representativeMobile || ''
        this.managementreptdesignation = data.representativeDesignation || ''
        this.schoolregistrationnumber = data.schoolRegistrationNumber || ''
        this.principalname = data.principalName || ''
        this.principalemail = data.principalEmail || ''
        this.principalmobile = data.principalMobile || ''
        this.principalhighqualification = data.principalHighestQualification || ''
        this.principalprofqualification = data.principalProfessionalQualification || ''
        this.principalCertificate = null
        this.existingCertificates.principalCertificate = (data.principalCertificate && data.principalCertificate !== 'null') ? data.principalCertificate : null

        // Set class details
        if (data) {
          this.classDetails.nursery.boys = data.totalnurseryboys || ''
          this.classDetails.nursery.girls = data.totalnurserygirls || ''
          this.classDetails.nursery.classrooms = data.nurserytotalClassrooms || ''
          this.classDetails['pp II'].boys = data.totalpp2boys || ''
          this.classDetails['pp II'].girls = data.totalpp2girls || ''
          this.classDetails['pp II'].classrooms = data.pp2totalClassrooms || ''
        }
        // Infra
        this.infra.buildingType = data.buildingType || ''
        this.infra.buildingCert = null
        this.existingCertificates.buildingCert = (data.buildingCompletionCertificate && data.buildingCompletionCertificate !== 'null') ? data.buildingCompletionCertificate : null
        this.infra.healthHygiene = data.healthHygieneMaintained ? 'yes' : 'no'
        this.infra.sanitation = data.sanitationMaintained ? 'yes' : 'no'
        this.infra.cleanliness = data.cleanlinessMaintained ? 'yes' : 'no'
        this.infra.cleanlinessCert = null
        this.existingCertificates.cleanlinessCert = (data.cleanlinessMaintenanceCertificate && data.cleanlinessMaintenanceCertificate !== 'null') ? data.cleanlinessMaintenanceCertificate : null
        this.infra.facility = data.facility ? JSON.parse(data.facility) : ''
        this.infra.washrooms = data.totalWashrooms || ''
        this.infra.area = data.areapreSchoolsqft || ''
        this.infra.waterStorage = data.waterStorageCapacityLiters || ''
        this.infra.attendants = data.attendantsAvailable ? 'yes' : 'no'
        this.infra.attendantMale = data.attendantsMale || 0
        this.infra.attendantFemale = data.attendantsFemale || 0
        this.infra.specialNeeds = data.childrenSpecialneeds ? 'yes' : 'no'
        this.specialNeedsInput.nursery.boys = data.specialneedsNurseryBoys !== undefined ? data.specialneedsNurseryBoys : ''
        this.specialNeedsInput.nursery.girls = data.specialneedsNurseryGirls !== undefined ? data.specialneedsNurseryGirls : ''
        this.specialNeedsInput['pp II'].boys = data.specialneedsPP2Boys !== undefined ? data.specialneedsPP2Boys : ''
        this.specialNeedsInput['pp II'].girls = data.specialneedsPP2Girls !== undefined ? data.specialneedsPP2Girls : ''
        // Staff
        const names = (data.staffName || '').split(',').map(x => x.trim())
        const types = (data.staffType || '').split(',').map(x => x.trim())
        const highestEdus = (data.staffHighestedu || '').split(',').map(x => x.trim())
        const profQualifications = (data.staffProfessionalQualification || '').split(',').map(x => x.trim())
        const dobs = (data.staffDateOfBirth || '').split(',').map(x => x.trim())
        const dojs = (data.staffDateOfJoin || '').split(',').map(x => x.trim())
        const genders = (data.staffGender || '').split(',').map(x => x.trim())
        const certsRaw = (data.staffCertifications || '').split(',').map(x => x.trim())
        const certifications = certsRaw.map(c => c ? c.split('|').map(y => y.trim()) : [])

        const staffCount = Math.max(
          names.length,
          types.length,
          highestEdus.length,
          profQualifications.length,
          dobs.length,
          dojs.length,
          genders.length,
          certifications.length
        )
        this.staffList = Array.from({ length: staffCount }, (_, i) => ({
          name: names[i] || '',
          type: types[i] || '',
          highestEdu: highestEdus[i] || '',
          profQualification: profQualifications[i] || '',
          dob: dobs[i] ? dobs[i].slice(0, 10) : '',
          doj: dojs[i] ? dojs[i].slice(0, 10) : '',
          gender: genders[i] || '',
          certifications: certifications[i] || []
        }))
        // If no staff found, provide one empty row
        if (!this.staffList.length) {
          this.staffList = [{
            name: '',
            type: '',
            highestEdu: '',
            profQualification: '',
            dob: '',
            doj: '',
            gender: '',
            certifications: []
          }]
        }
      } catch (e) {
        // handle error
      }
    },
    extractS3Key (url) {
      const base = 'https://intellitots.s3.ap-south-1.amazonaws.com/'
      if (url.startsWith(base)) {
        let key = url.substring(base.length)
        try {
          key = decodeURIComponent(key)
        } catch (e) {}
        if (key.match(/%[0-9A-Fa-f]{2}/)) {
          key = decodeURIComponent(key)
        }
        return key
      }
      return url
    },
    downloadCertificate: async function (fileUrlOrKey) {
      const s3key = this.extractS3Key(fileUrlOrKey)
      let response = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${encodeURIComponent(s3key)}`)
      window.open(response.data)
    },
    async updateCenterDetails () {
      if (!this.formValidation()) {
        return
      }
      const formData = new FormData()
      formData.append('preSchoolName', this.preschoolname)
      formData.append('franchiseeID', this.preschoolname)
      formData.append('district', this.district)
      formData.append('block', this.block)
      formData.append('village', this.village)
      formData.append('nearestPrimarySchool', this.nearestPrimarySchool)
      formData.append('cluster', this.cluster)
      formData.append('preSchoolNumber', this.preschoolnumber)
      formData.append('addressLandmark', this.address)
      formData.append('management', this.management)
      formData.append('medium', this.medium)
      formData.append('category', this.category)
      formData.append('preSchoolEmail', this.preschoolEmail)
      formData.append('preSchoolContactNo', this.preschoolContactNo)
      formData.append('academicYearStarted', this.preschoolacademicYear)
      formData.append('preSchoolWebsite', this.preschoolwebsite)
      formData.append('lowestClass', this.lowestClass)
      formData.append('highestClass', this.highestClass)
      formData.append('representativeName', this.managementreptname)
      formData.append('representativeEmail', this.managementreptemail)
      formData.append('representativeMobile', this.managementreptmobile)
      formData.append('representativeDesignation', this.managementreptdesignation)
      formData.append('schoolRegistrationNumber', this.schoolregistrationnumber)
      formData.append('principalName', this.principalname)
      formData.append('principalEmail', this.principalemail)
      formData.append('principalMobile', this.principalmobile)
      formData.append('principalHighestQualification', this.principalhighqualification)
      formData.append('principalProfessionalQualification', this.principalprofqualification)
      // formData.append('principalCertificate', this.principalCertificate)
      if (this.principalCertificateRemoved) {
        formData.append('principalCertificate', '')
      } else if (this.principalCertificate) {
        formData.append('principalCertificate', this.principalCertificate)
      }
      // class details
      formData.append('totalnurseryboys', this.classDetails.nursery.boys)
      formData.append('totalnurserygirls', this.classDetails.nursery.girls)
      formData.append('totalpp2boys', this.classDetails['pp II'].boys)
      formData.append('totalpp2girls', this.classDetails['pp II'].girls)
      formData.append('nurserytotalClassrooms', this.classDetails.nursery.classrooms)
      formData.append('pp2totalClassrooms', this.classDetails['pp II'].classrooms)
      // infra
      formData.append('buildingType', this.infra.buildingType)
      if (this.buildingCertRemoved) {
        formData.append('buildingCompletionCertificate', '')
      } else if (this.infra.buildingCert) {
        formData.append('buildingCompletionCertificate', this.infra.buildingCert)
      }

      formData.append('healthHygieneMaintained', this.infra.healthHygiene === 'yes')
      formData.append('sanitationMaintained', this.infra.sanitation === 'yes')
      formData.append('cleanlinessMaintained', this.infra.cleanliness === 'yes')
      if (this.cleanlinessCertRemoved) {
        formData.append('cleanlinessMaintenanceCertificate', '')
      } else if (this.infra.cleanlinessCert) {
        formData.append('cleanlinessMaintenanceCertificate', this.infra.cleanlinessCert)
      }
      formData.append('facility', this.infra.facility && this.infra.facility.length ? JSON.stringify(this.infra.facility) : '')
      formData.append('totalWashrooms', this.infra.washrooms)
      formData.append('areapreSchoolsqft', this.infra.area)
      formData.append('waterStorageCapacityLiters', this.infra.waterStorage)
      formData.append('attendantsAvailable', this.infra.attendants === 'yes')
      formData.append('attendantsMale', this.infra.attendantMale)
      formData.append('attendantsFemale', this.infra.attendantFemale)
      formData.append('childrenSpecialneeds', this.infra.specialNeeds === 'yes')
      if (this.infra.specialNeeds === 'yes') {
        // Nursery
        formData.append('specialneedsNurseryBoys', Number(this.specialNeedsInput.nursery.boys || 0))
        formData.append('specialneedsNurseryGirls', Number(this.specialNeedsInput.nursery.girls || 0))
        // PP II
        formData.append('specialneedsPP2Boys', Number(this.specialNeedsInput['pp II'].boys || 0))
        formData.append('specialneedsPP2Girls', Number(this.specialNeedsInput['pp II'].girls || 0))
        // PP II Total
        formData.append('specialneedsPP2Total', Number(this.specialNeedsInput['pp II'].boys || 0) + Number(this.specialNeedsInput['pp II'].girls || 0))
        // Nursery Total (if you want)
        formData.append('specialneedsNurseryTotal', Number(this.specialNeedsInput.nursery.boys || 0) + Number(this.specialNeedsInput.nursery.girls || 0))
      }
      // staff
      formData.append('staffName', this.staffList.map(s => s.name || '').join(', '))
      formData.append('staffType', this.staffList.map(s => s.type || '').join(', '))
      formData.append('staffHighestedu', this.staffList.map(s => s.highestEdu || '').join(', '))
      formData.append('staffProfessionalQualification', this.staffList.map(s => s.profQualification || '').join(', '))
      formData.append('staffDateOfBirth', this.staffList.map(s => s.dob || '').join(','))
      formData.append('staffDateOfJoin', this.staffList.map(s => s.doj || '').join(','))
      formData.append('staffGender', this.staffList.map(s => s.gender || '').join(', '))
      formData.append('staffCertifications', this.staffList
        .map(s => Array.isArray(s.certifications) ? s.certifications.join('|') : s.certifications)
        .join(', ')) // Certifications: join each staff's certifications with '|', then join all staffs with ','
      try {
        const id = this.$route.params.id
        await http.put(`${constants.API_URL}/api/centerdetailsPreschool/editcenterdetails/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        await this.getCenterLogDetails()
        this.$router.push({ name: 'preschooldetails', params: { id: this.id } })
      } catch (e) {
        // handle/update error
      }
    },
    cancelEdit () {
      this.$router.go(-1)
    },
    getAllFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.allFranchisees = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async getCenterLogDetails () {
      this.isLoading = true
      try {
        let result = await http.get(
          `${constants.API_URL}/api/centerdetailsPreschool/editpreschoollog?preSchoolName=${this.preschoolname}`
        )
        this.preschoollist = result.data
        this.total = this.preschoollist.length
      } catch (e) {
        this.preschoollist = []
      } finally {
        this.isLoading = false
      }
    },
    addStaff () {
      this.staffList.push({
        name: '',
        type: '',
        highestEdu: '',
        profQualification: '',
        dob: '',
        doj: '',
        gender: '',
        certifications: []
      })
    },
    removeStaff (index) {
      if (this.staffList.length > 0) {
        this.staffList.splice(index, 1)
      }
    },
    removeCertificate (certType) {
      if (certType === 'buildingCert') {
        this.infra.buildingCert = null
        this.existingCertificates.buildingCert = null
        this.buildingCertRemoved = true
      }
      if (certType === 'cleanlinessCert') {
        this.infra.cleanlinessCert = null
        this.existingCertificates.cleanlinessCert = null
        this.cleanlinessCertRemoved = true
      }
      if (certType === 'principalCertificate') {
        this.principalCertificate = null
        this.existingCertificates.principalCertificate = null
        this.principalCertificateRemoved = true
      }
    },
    validateStaffList () {
      for (let i = 0; i < this.staffList.length; i++) {
        const staff = this.staffList[i]
        const entryNo = i + 1

        if (!staff.name || staff.name.trim() === '') {
          this.errMsg(`Staff Name cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.type || staff.type.trim() === '') {
          this.errMsg(`Staff Teaching Type cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.highestEdu || staff.highestEdu.trim() === '') {
          this.errMsg(`Staff Highest Educational Qualification cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.profQualification || staff.profQualification.trim() === '') {
          this.errMsg(`Staff Professional Qualification cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.dob || staff.dob.trim() === '') {
          this.errMsg(`Staff Date of Birth cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.doj || staff.doj.trim() === '') {
          this.errMsg(`Staff Date of Joining cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!staff.gender || staff.gender.trim() === '') {
          this.errMsg(`Staff Gender cannot be empty! (Row ${entryNo})`)
          return false
        }
        if (!Array.isArray(staff.certifications) || staff.certifications.length === 0) {
          this.errMsg(`Staff Professional Qualification Certifications cannot be empty! (Row ${entryNo})`)
          return false
        }
      }
      return true
    },
    formValidation () {
      if (!this.validateStaffList()) {
        return false
      }
      if (this.preschoolname === '') {
        this.errMsg('PreschoolName cannot be empty!')
      } else if (!this.district || this.district.trim() === '') {
        this.errMsg('District cannot be empty!')
      } else if (!this.block || this.block.trim() === '') {
        this.errMsg('Block cannot be empty!')
      } else if (!this.village || this.village.trim() === '') {
        this.errMsg('Village cannot be empty!')
      } else if (!this.nearestPrimarySchool || this.nearestPrimarySchool.trim() === '') {
        this.errMsg('NearestPrimary School cannot be empty!')
      } else if (!this.lowestClass || this.lowestClass.trim() === '') {
        this.errMsg('LowestClass cannot be empty!')
      } else if (!this.highestClass || this.highestClass.trim() === '') {
        this.errMsg('HighestClass cannot be empty!')
      } else if (!this.principalname || this.principalname.trim() === '') {
        this.errMsg('Principal/Headmaster/In-charge Name cannot be empty!')
      } else if (!this.principalmobile || this.principalmobile.trim() === '') {
        this.errMsg('Principal/Headmaster/In-charge Mobile cannot be empty!')
      } else {
        return true
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.main-section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #0284df;
  margin-top: 18px;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}
.section-wrapper {
  background: #eaf6ff;
  border-radius: 12px;
  padding: 24px 12px 12px 12px;
  margin-bottom: 32px;
  position: relative;
  border: 2px solid #0a0a0a;
}
.basic-info-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(2,132,223,0.04);
  background: #fff;
  margin-top: 18px;
}
.tab-label {
  position: absolute;
  top: -18px;
  left: 18px;
  background: #0284df;
  color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 4px 28px;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(2,132,223,0.14);
  z-index: 2;
}
.scroll-wrapper {
  overflow-x: auto;
  width: 100%;
}
</style>
